import { styled } from '@linaria/react';
import { Badge } from '../../components/Badge';
import { Toast } from '../../components/Toast';
import { fonts, layout, primitives, semantic, size, space, textStyle } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    overflow: visible;
  }
`;

export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: ${layout.mobileNavHeight};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding-bottom: 0;
  }
`;

export const HeaderGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
`;

export const UrgencyBadge = styled(Badge)`
  align-self: flex-end;
`;

export const Title = styled.h1`
  font-family: ${textStyle.headline['size-lg'].fontFamily};
  font-size: ${textStyle.headline['size-lg'].fontSize};
  font-weight: ${textStyle.headline['size-lg'].fontWeight};
  line-height: ${textStyle.headline['size-lg'].lineHeight};
  letter-spacing: ${textStyle.headline['size-lg'].letterSpacing};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const ItemsSection = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
  margin: ${space['space-800']} 0 0;
  padding: 0;
  list-style: none;

  @media (min-width: ${layout.desktopBreakpoint}) {
    margin-top: ${space['space-1000']};
  }
`;

export const ItemsItem = styled.li`
  display: block;
`;

export const ShowMoreRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${space['space-600']};
`;

export const MetaLabel = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  line-height: ${primitives.typography.lineHeight.normal};
  color: ${semantic.text.primary};
  margin: ${space['space-1000']} 0 0;
`;

export const DescriptionSection = styled.div`
  margin-top: ${space['space-1000']};
  font-size: ${fonts.size.base};

  ${MetaLabel} + & {
    margin-top: ${space['space-400']};
  }
`;

export const TriggerSection = styled.div`
  margin-top: ${space['space-1000']};
`;

export const TriggerRow = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${space['space-600']} 0;
  background: none;
  border: none;
  border-bottom: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  cursor: pointer;
  text-align: left;

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: ${space['space-050']};
  }
`;

export const NotificationSection = styled.div`
  margin-top: ${space['space-1000']};
`;

export const RecoverySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-1000']};
  margin-top: ${space['space-800']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    margin-top: ${space['space-1000']};
  }
`;

export const RecoveryToast = styled(Toast)`
  && {
    width: 100%;
  }
`;

export const AlternativesSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${space['space-600']};
`;

export const AlternativesList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const ActionBarArea = styled.div`
  @media (min-width: ${layout.desktopBreakpoint}) {
    position: sticky;
    bottom: 0;
    background: ${semantic.bg.canvas};
    border-top: ${size.stroke['stroke-default']} solid ${semantic.border.default};
    padding-bottom: ${space['space-600']};
  }
`;

export const Spacer = styled.div`
  height: ${space['space-800']};
`;
